import { useEffect, useState } from 'react';

type NetworkInformation = {
  saveData?: boolean;
  addEventListener?: (type: 'change', listener: () => void) => void;
  removeEventListener?: (type: 'change', listener: () => void) => void;
};

/** Tracks the Save-Data client hint so heavy or decorative media can be skipped. */
export function useSaveData() {
  const connection = (navigator as Navigator & { connection?: NetworkInformation }).connection;
  const [saveData, setSaveData] = useState(() => Boolean(connection?.saveData));

  useEffect(() => {
    const update = () => setSaveData(Boolean(connection?.saveData));
    connection?.addEventListener?.('change', update);
    return () => connection?.removeEventListener?.('change', update);
  }, [connection]);

  return saveData;
}
